import React, { Component } from 'react';
import $ from 'jquery';
import axios from "axios";
import { setCookie, getCookie, login_check, loginUrl, pocketUrl } from './Common';

class SecQuiz extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null,       // JSON 데이터를 저장할 곳
      quizDate: '',
      loading: true,    // 로딩 상태
      error: null       // 에러 메시지 저장
    };
  }

  async componentDidMount() {

    const publicUrl = process.env.PUBLIC_URL;
    let corAnswer, corDescript, quizGubn;
    const retLogin = await login_check();
    const refUrl = process.env.REACT_APP_USER_WWW + '/snslogin/PocketLogingDone.php?loc=MyQuiz';
    let quizDate;
    try {
      const response = await axios.get(publicUrl + '/api/getTodayQuiz.php');
      const retData = response.data;

      quizGubn = retData.gubn;
      let qDate = retData.date.split("-");
      quizDate = retData.date;
      $("#quizDate").val(retData.date);
      let qDateTxt = qDate[0] + "년 " + Number(qDate[1]) + "월 " + Number(qDate[2]) + "일";
      if (quizGubn == 'm') {
        $("#quizox").hide();
        $("#quizmulti").show();
        $("#quizDatem").text(qDateTxt);
        $("#quizTitlem").text(retData.question);
        $("#quiz1").text(retData.choice1);
        $("#quiz2").text(retData.choice2);
        $("#quiz3").text(retData.choice3);
        $("#quiz4").text(retData.choice4);
      } else {
        $("#quizox").show();
        $("#quizmulti").hide();
        $("#quizDateo").text(qDateTxt);
        $("#quizTitleo").text(retData.question);

      }

      corAnswer = retData.answer;
      corDescript = retData.description;
      const userAnswer = retData.useranswer;
      let pocketTodayQuizCookie = userAnswer;

      if (
        pocketTodayQuizCookie === undefined ||
        pocketTodayQuizCookie === null ||
        pocketTodayQuizCookie === ''
      ) {
        pocketTodayQuizCookie = getCookie('pocketTodayQuiz');
      }

      if (
        pocketTodayQuizCookie !== undefined &&
        pocketTodayQuizCookie !== null &&
        pocketTodayQuizCookie !== ''
      ) {
        const pocketTodayQuizCookieSplit = pocketTodayQuizCookie.split("|");
        const pocketTodayQuiz = pocketTodayQuizCookieSplit[0];
        const pocketTodayQuizGubn = pocketTodayQuizCookieSplit[1];
        if (pocketTodayQuizGubn == quizGubn) {
          const $quiz = $('.section--quiz .quiz');
          const $quizAnswer = $quiz.find('.quiz__a');
          let isCorrect = false;

          const publicUrl = process.env.PUBLIC_URL;
          let quizCrossUrl = publicUrl + '/api/setCrossAnswer.php?week=' + quizDate + '&word=' + pocketTodayQuizCookie + '&mode=quiz';
          let response = axios.get(quizCrossUrl);
          // 상태 초기화//
          $quiz.removeClass('quiz--pass quiz--fail');
          $quiz.find('.quiz__result').remove();
          $quiz.find('.quiz__result__txt').remove();
          $quiz.find('.quiz__result__btn').remove();
          $quiz.find('.btn').attr('disabled', true);

          $("#quiz" + pocketTodayQuiz).addClass('selected');
          if (corAnswer.toString() == pocketTodayQuiz.toString()) { //정답
            isCorrect = true;
          }


          if (isCorrect) {
            $quiz.addClass('quiz--pass');

            let resultHtml = `
            <div class="quiz__explain">
              <p class="answer">정답 : ${corAnswer}</p>
              <p class="explanation">${corDescript}</p>
            </div>`;
            resultHtml += `<button type="button" class="quiz__explain__toggle"> 해설 보기 </button>`;
            if (!retLogin) {
              resultHtml += `
              <button class="quiz__result__txt" onclick="window.location.href='`+ loginUrl + '?ref=' + encodeURIComponent(refUrl) + `'">
              로그인하고 퀴즈 내역 남기기 👉
              </button>`;
            } else {
              resultHtml += `
              <a href="/MyQuiz" class="quiz__result__txt">
                퀴즈 내역 보러 가기 👉
              </a>`;
            }

            $quizAnswer.after(resultHtml);
            $quiz.addClass('quiz--pass');
            $('.quiz__explain__toggle').addClass('active');
            $quiz.find('.quiz__explain').addClass('active'); // .show();
            $quiz.find('.quiz__explain__toggle').text('해설 접기');
          } else {
            // 오답일때
            $quiz.addClass('quiz--fail');
            $quizAnswer.after(`
          <p class="quiz__result__txt">오답이에요! 다시 풀어보세요🔥</p>
          `);

            setTimeout(() => {
              //1초 후 노출
              $quiz.find('.date').after(`
            <button type="button" class="quiz__result__btn btn--retry">재도전</button>
            `);
            }, 0);
          }
          ////document.getElementById("quiz"+pocketTodayQuiz).click();

          //        const $quiz = $('.section--quiz .quiz');
          //const $quizAnswer = $('.section--quiz .quiz .quiz__a');

        }
      }
      this.setState({
        data: response.data,   // JSON 전체를 저장
        quizDate: retData.date,
        loading: false
      });
    } catch (error) {
      this.setState({
        error: error.message,
        loading: false
      });
    };

    // 퀴즈 정답 클릭시 처리 샘플
    $('.quiz')
      .find('.btn')
      .on('click', function () {
        // TODO:정답 1번으로 임의 설정

        let isCorrect = false;
        let ansNum;
        if (quizGubn == 'm') {
          ansNum = '' + ($(this).index() + 1);
          if (ansNum == corAnswer)
            isCorrect = true;
        } else if (quizGubn == 'o') {
          ansNum = $(this).val();
          if (ansNum == corAnswer)
            isCorrect = true;
        }
        const quizAnswer = ansNum + '|' + quizGubn;
        setCookie('pocketTodayQuiz', ansNum + '|' + quizGubn);
        const $quiz = $(this).closest('.quiz');
        const $quizAnswer = $quiz.find('.quiz__a');

        // 상태 초기화
        $quiz.removeClass('quiz--pass quiz--fail');
        $quiz.find('.quiz__result').remove();
        $quiz.find('.quiz__result__txt').remove();
        $quiz.find('.quiz__result__btn').remove();
        $quiz.find('.btn').attr('disabled', true);

        $(this).addClass('selected');
        const publicUrl = process.env.PUBLIC_URL;
        const quizWordUrl = publicUrl + '/api/setCrossAnswer.php?week=' + quizDate + '&word=' + quizAnswer + '&mode=quiz';
        const response = axios.get(quizWordUrl);
        const retData = response.data;
        if (isCorrect) {
          //정답일때

          //팝업열기
          popupOpen('popup--quizPass');

          $quiz.addClass('quiz--pass');

          let resultHtml = `
              <div class="quiz__explain active">
                <p class="answer">정답 : ${corAnswer}</p>
                <p class="explanation">${corDescript}</p>
              </div>`;

          resultHtml += `<button type="button" class="quiz__explain__toggle"> 해설 보기 </button>`;

          if (!retLogin) {
            resultHtml += `
                <button class="quiz__result__txt" onclick="window.location.href='`+ loginUrl + '?ref=' + encodeURIComponent(refUrl) + `'">
                  로그인하고 퀴즈 내역 남기기 👉
                </button>`;
          } else {
            resultHtml += `<a href="/MyQuiz" class="quiz__result__txt">
                  퀴즈 내역 보러 가기 👉
                </a>`;
          }

          $quizAnswer.after(resultHtml);
          $quiz.addClass('quiz--pass');
          $('.quiz__explain__toggle').addClass('active');
          $quiz.find('.quiz__explain').addClass('active'); // .show();
          $quiz.find('.quiz__explain__toggle').text('해설 접기');
        } else {
          // 오답일때
          $quiz.addClass('quiz--fail');
          $(this).addClass('fail-ani'); //오답 interaction
          $quizAnswer.after(`
            <p class="quiz__result__txt">오답이에요! 다시 풀어보세요🔥</p>
            `);

          setTimeout(() => {
            //1초 후 노출
            $quiz.find('.date').after(`
              <button type="button" class="quiz__result__btn btn--retry">재도전</button>
              `);
          }, 1000);
        }
      });

    // 재도전 버튼 클릭
    $(document).on('click', '.btn--retry', function () {
      const $quiz = $(this).closest('.quiz');
      $quiz.removeClass('quiz--fail');
      $quiz.find('.quiz__a .btn').removeClass('selected').removeClass('fail-ani').attr('disabled', false);
      $quiz.find('.quiz__result__txt').remove();
      $quiz.find('.quiz__result__btn').remove();
      $quiz.find('.quiz__explain').remove();
      $quiz.find('.quiz__explain__toggle').remove();
    });

    //해설보기 토글
    $(document).on('click', '.quiz__explain__toggle', function () {
      const $btn = $(this);
      const $explain = $btn.prev('.quiz__explain');

      if ($btn.hasClass('active')) {
        $btn.removeClass('active');
        $explain.removeClass('active'); // .hide();
        $btn.text('해설 보기');
      } else {
        $btn.addClass('active');
        $explain.addClass('active'); // .show();
        $btn.text('해설 접기');
      }
    });

    function popupOpen(e) { return $("#" + e).fadeIn().css("display", "flex"), !1 }
    //
  }

  render() {
    const { quizDate } = this.state;
    return (
      <section className="section section--quiz">
        <div className="title-bx">
          <h2 className="tit"> 오늘의 용어 퀴즈 </h2>
        </div>
        <article className="quiz" data-quiz-id="0" id="quizox">
          <div className="wrap">
            <p className="date" id="quizDateo"> 2025년 5월 20일 </p>
            <h3 className="quiz__q" id="quizTitleo">통화유통속도는 국민총소득을 통화량으로 나눠 계산한다.</h3>
            <div className="quiz__a quiz__a--ox">
              <button type="button" id="quizO" className="btn btn--o" value='O'> </button>
              <button type="button" id="quizX" className="btn btn--x" value='X'> </button>
            </div>
          </div>
        </article>
        <></>
        <article className="quiz" data-quiz-id="1" id="quizmulti" style={{ display: 'none' }}>
          <div className="wrap">
            <p className="date" id="quizDatem"> 2025년 5월 20일 </p>
            <h3 className="quiz__q" id="quizTitlem">다음 중 캐시 카우(Cash Cow)에 대해 잘못된 설명은 무엇인가?</h3>
            <div className="quiz__a quiz__a--select">
              <button type="button" className="btn" id="quiz1" value="1"> 현재의 수익 창출이라는 측면에서는 안정적이지만, 미래 발전가능성은 높지 않다.</button>
              <button type="button" className="btn" id="quiz2" value="2"> 캐시 카우로 분류되는 제품이나 산업은 잘 다져진 브랜드 명성을 갖고 있다.</button>
              <button type="button" className="btn" id="quiz3" value="3"> 미국 보스턴컨설팅그룹(BCG)에서 처음 사용했다.</button>
              <button type="button" className="btn" id="quiz4" value="4"> 어떤 사업을 위해 출자를 하는 것을 말한다.</button>
            </div>
          </div>
        </article>
        <input type='hidden' value={quizDate} id="quizDate" />
      </section>



    );
  }
}

export default SecQuiz;    